module.exports = __webpack_public_path__ + "images/emoji/white_medium_square.479adce06b02f540db76.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/white_medium_square.png
// module id = Q0Ex
// module chunks = 2